import manageOpenAIResponse from "../../../../actions/aiFeatures/OpenAI/manageOpenAIResponse";
import { ownerPrompt } from "../../../../lib/AIFeatures/Prompt/ownerPrompt";

const submit = (values, dispatch) => {
    let prompt;
    const location = values?.preferences?.[0]?.value || '';
    const carFeatures = values?.preferences?.[1]?.value || '';
    const carDetails = values?.preferences?.[2]?.value || '';
    const lang = values?.language || 'en';
    const targetRenters = values?.targetRenters || 'All';
    prompt = ownerPrompt.carTitleDescription({
        location,
        carFeatures,
        carDetails,
        lang,
        targetRenters
    });

    dispatch(manageOpenAIResponse({ name: 'carTitleDescription', prompt }));
};

export default submit;
